<template>
  <div class="wrap1">
    <h2 class="common-title">
      <span>
        <i class="el-icon-arrow-left back" @click="handlerBack"></i>
        {{ $t('certificate_staff_10') }}
      </span>
      <div>
        <el-button size="small" @click="handleEdit()" type="primary">{{ $t('certificate_staff_14') }}</el-button>
      </div>
    </h2>
    <div class="wrap1-box" ref="wrap">
      <el-tabs v-model="query.status" @tab-click="handleClick">
        <el-tab-pane :label="$t('certificate_staff_20')" name="1"></el-tab-pane>
        <el-tab-pane :label="$t('pay_slip_20')" name="2"></el-tab-pane>
      </el-tabs>
      <div v-if="timeDataLen === 0">{{ $t('no_data') }}</div>
      <ul v-else>
        <li v-for="item in timeData" :key="item.name">
          <h2>
            <span class="title">{{ item.name }}</span>
            <span v-html="$t('certificate_staff_15', { key: item.send_time })"></span>
          </h2>
          <!-- 发送对象 -->
          <div class="item">
            <label>{{ $t('certificate_staff_16') }}：</label>
            <div class="item-content">
              <span v-for="(department, index) in item.departments_lists" :key="index + 'department'">
                {{ department && department.department_name }},
              </span>
              <span v-for="(staff, index) in item.staff_lists" :key="index + 'staff'">
                {{ staff && staff.staff_name }}<template v-if="index !== item.staff_lists.length - 1">,</template>
              </span>
              <span>
                {{
                  $t('912', {
                    x: item.departments_lists && item.departments_lists.length,
                    y: item.staff_lists && item.staff_lists.length
                  })
                }}</span
              >
            </div>
          </div>
          <!-- 文件类型 -->
          <div class="item">
            <label>{{ $t('certificate_staff_17') }}：</label>
            <span class="item-content">{{ item.type_txt }}</span>
          </div>
          <div class="info">
            <span v-html="$t('certificate_staff_18', { name: item.create_name, time: item.created_at })"></span>
            <div>
              <el-button
                v-if="query.status === '1'"
                size="small"
                @click="handleEdit(item)"
                type="primary"
                :disabled="item.send_state"
              >
                <el-tooltip
                  effect="dark"
                  v-if="item.send_state"
                  :content="$t('certificate_module_12')"
                  placement="top-start"
                >
                  <span>{{ $t('action.update') }}</span> </el-tooltip
                ><span v-else>{{ $t('action.update') }}</span></el-button
              >
              <el-button
                v-if="query.status === '1'"
                size="small"
                @click="handleCancel(item)"
                :disabled="item.send_state"
              >
                <el-tooltip effect="dark" v-if="item.send_state" :content="$t('pay_slip_43')" placement="top-start">
                  <span>{{ $t('certificate_staff_19') }}</span> </el-tooltip
                ><span v-else>{{ $t('certificate_staff_19') }}</span></el-button
              >
              <el-button v-if="query.status === '2'" size="small" @click="handleView(item)">{{
                $t('from_info')
              }}</el-button>
            </div>
          </div>
        </li>
      </ul>
      <!-- 分页器 -->
      <Pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        :current-page="query.page"
        :page-size="query.page_size"
        :page-sizes="page.pageSizes"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <addTiming ref="addTiming" @handleSave="handleSave"></addTiming>
  </div>
</template>

<script>
import {
  getCertificateList, // 定时任务——列表查询
  cancelCertificateTask, // 定时任务—取消定时任务
  addCertificateTask, // 定时任务—新建定时任务
  editCertificateTask, // 定时任务—编辑定时任务
  infoCertificateTask // 定时任务——任务详情
} from 'api/payroll/prove-download'
import Pagination from '_c/pagination'
import addTiming from '../component/addTiming'
export default {
  components: { addTiming, Pagination },
  props: {},
  data() {
    return {
      query: {
        status: '1',
        page: 1,
        page_size: 20
      },
      page: {
        pageSizes: [20, 50, 100],
        total: 0
      },
      timeData: [],
      timeDataLen: -1
    }
  },
  created() {
    this.getCertificateList(1)
  },
  methods: {
    handlerBack() {
      // 返回列表页
      this.$router.push({ path: '/certificate/staff' })
    },
    handleClick() {
      this.getCertificateList(1)
    },
    getCertificateList(page) {
      // 获取数据列表
      this.query.page = page
      getCertificateList(this.query).then(res => {
        res.data.list.forEach(item => {
          const sendTime = new Date(item.send_time).getTime()
          const newTime = new Date().getTime()
          item.send_state = sendTime - newTime <= 1000 * 60 * 10
        })
        this.timeData = res.data.list
        this.page.total = res.data.page_data.total
        this.timeDataLen = this.page.total
        this.$nextTick(() => {
          if (this.$refs.wrap) this.$refs.wrap.scrollTop = 0
        })
      })
    },
    handleCurrentChange(page) {
      this.getCertificateList(page)
    },
    handleSizeChange(size) {
      this.query.page_size = size
      this.getHistoryList(1)
    },
    handleSave(data) {
      // 保存 or 新建
      const api = data.id ? editCertificateTask : addCertificateTask
      api(data).then(res => {
        this.$refs.addTiming.handleClose()
        this.$message.success(res.message)
        this.getCertificateList(this.query.page)
      })
    },
    async handleEdit(row) {
      let res = {}
      if (row) {
        const data = await infoCertificateTask({ id: row.id })
        res = data.data
      }
      this.$refs.addTiming.init(res)
    },
    handleCancel(row) {
      // 取消发送
      cancelCertificateTask({ id: row.id }).then(res => {
        this.$message.success(res.message)
        this.getCertificateList(this.query.page)
      })
    },
    handleView(item) {
      this.$router.push({
        path: '/certificate/timing-staff-view/5',
        query: {
          id: item.id,
          name: item.name
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap1 {
  .common-title {
    display: flex;
    span {
      flex: 1;
    }
  }
  &-box {
    padding: 24px 24px 0;
    h2 {
      font-weight: 500;
      font-size: 14px;
      color: #262626;
      line-height: 22px;
      margin-bottom: 12px;
    }
    ul {
      li {
        padding: 24px;
        box-sizing: border-box;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        margin-bottom: 16px;
        h2 {
          width: 100%;
          display: flex;
          .title {
            flex: 1;
            font-size: 16px;
            color: #262626;
          }
          span {
            font-weight: 400;
            font-size: 14px;
            color: #8c8c8c;
          }
        }
        .item {
          font-size: 14px;
          color: #262626;
          margin-top: 12px;
          display: flex;
          &-content {
            flex: 1;
            max-width: 70%;
          }
          span {
            color: #595959;
          }
        }
        .info {
          font-size: 14px;
          color: #8c8c8c;
          margin-top: 12px;
          display: flex;
          align-items: center;
          span {
            flex: 1;
          }
        }
      }
    }
  }
}
/deep/.sign {
  color: #5D51DA;
}
h2 {
  margin: 0;
}
</style>
